<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <fuse-alert
        *ngIf="showAlert"
        class="fixed z-50 top-4 right-5"
        [appearance]="'border'"
        [dismissible]="false"
        [showIcon]="true"
        [type]="alert.type"
        @fadeInRight>
        {{ alert.message }}
    </fuse-alert>
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class="text-black title-6 md:title-3">Fórmulas y parámetros</h1>
    </div>
    <p class="mt-8 title-8 text-primary-black-01">Estados</p>

    <!-- ITEMS MOBILE -->
    <div class="grid grid-cols-1 gap-2 py-2 md:hidden sm:grid-cols-2">
        <div *ngFor="let item of estadosPagare; let i = index" class="relative flex flex-col justify-start p-4 text-left border-2 rounded-lg md:p-6">
            <p class="paragraph-4">Estado: {{ item.NOMBRE_ESTADO }}</p>

            <mat-form-field class="w-full h-12 mt-1.5">
                <input
                    [(ngModel)]="item.VALOR"
                    matInput
                    type="text"
                    placeholder="Ingresar nuevo nombre"
                    class=""
                    pattern="^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]{1,50}$" />
            </mat-form-field>
        </div>
    </div>
    <!-- TABLE DESKTOP -->
    <div class="hidden w-full py-2 overflow-auto custom-scroll md:block">
        <table mat-table [dataSource]="estadosPagare" class="w-full" matSort>
            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="NOMBRE_ESTADO" class="px-1.5">ESTADO</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5">
                    {{ element.NOMBRE_ESTADO }}
                </td>
            </ng-container>
            <ng-container matColumnDef="nuevo">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="nuevo" class="px-1.5">NUEVO NOMBRE</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5">
                    <mat-form-field class="w-full h-12 mt-1.5">
                        <input
                            [(ngModel)]="element.VALOR"
                            matInput
                            type="text"
                            maxlength="20"
                            [patterns]="customPatterns"
                            [dropSpecialCharacters]="false"
                            mask="0*"
                            placeholder="Ingresar nuevo nombre"
                            class="" />
                    </mat-form-field>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <button mat-flat-button color="primary" class="w-full mt-5 md:w-48" (click)="guardarEstados()">Guardar</button>

    <form class="w-full md:w-120">
        <p class="mt-5 title-8 text-primary-black-01">Notificaciones</p>

        <!-- <mat-form-field appearance="fill" class="w-full mt-5">
            <mat-label>Area/Evento</mat-label>
            <mat-select class="h-[54px]" [(value)]="selected">
                <mat-option *ngFor="let area of areas" [value]="area.value">
                    {{ area.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-form-field hideRequiredMarker class="w-full">
            <mat-label>Email alerta de folios</mat-label>
            <input
                matInput
                type="text"
                placeholder="tributaria@clarochile.cl"
                class="h[26px]"
                required
                #email1="ngModel"
                pattern="^[a-zA-ZñÑáéíóúÁÉÍÓÚ ,.-@_]{1,100}$"
                [(ngModel)]="mailAlertaFolio"
                [ngModelOptions]="{ standalone: true }" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker class="w-full">
            <mat-label>Email aviso área judicial</mat-label>
            <input
                matInput
                type="text"
                placeholder="judicial@clarochile.cl"
                class="h[26px]"
                required
                #email2="ngModel"
                
                pattern="^[a-zA-ZñÑáéíóúÁÉÍÓÚ ,.-@_]{1,100}$"
                [(ngModel)]="mailJudicial"
                [ngModelOptions]="{ standalone: true }" />
        </mat-form-field>

        <button 
        [disabled]="!email1.valid ||!email2.valid" type="submit" mat-flat-button color="primary" class="w-full mt-5 md:w-48" (click)="guardarMailNotificaciones()">Guardar</button>
    </form>

    <form class="w-full md:w-120" #formPagare="ngForm" *ngIf="infoPagareFormulario24">
        <p class="mt-5 title-8 text-primary-black-01">Pagaré y formulario 24</p>

        <mat-form-field class="w-full mt-5 fuse-mat-emphasized-affix">
            <mat-label>Monto mínimo emisión de Pagaré</mat-label>
            <input
                matInput
                type="tel"
                placeholder="Monto mínimo emisión de Pagaré"
                class="h-[26px]"
                [(ngModel)]="infoPagareFormulario24.MONTO_MINIMO_EMISION_PAGARE.VALOR_RECURSO"
                maxlength="10"
                mask="separator.0"
                thousandSeparator="."
                #monto_minimo_pagare="ngModel"
                name="MONTO_MINIMO_EMISION_PAGARE"
                requiered />
            <span matPrefix>$</span>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Alerta solicitud de folios</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Alerta solicitud de folios"
                [(ngModel)]="infoPagareFormulario24.ALERTA_SOLICITUD_FOLIO.VALOR_RECURSO"
                maxlength="5"
                [dropSpecialCharacters]="false"
                mask="separator.0"
                thousandSeparator="."
                #alerta_folios="ngModel"
                name="ALERTA_SOLICITUD_FOLIO"
                requiered />
        </mat-form-field>

        <mat-form-field class="w-full fuse-mat-emphasized-affix">
            <mat-label>Tasa máxima (%)</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Tasa máxima (%)"
                [(ngModel)]="infoPagareFormulario24.TASA_MAXIMA.VALOR_RECURSO"
                maxlength="5"
                [dropSpecialCharacters]="false"
                mask="separator.3"
                thousandSeparator="."
                #tasa_maxima="ngModel"
                name="TASA_MAXIMA"
                requiered />
            <span matPrefix>%</span>
        </mat-form-field>

        <mat-form-field class="w-full mt-5">
            <mat-label>Razón Social</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Razón Social"
                [(ngModel)]="infoPagareFormulario24.RAZON_SOCIAL.VALOR_RECURSO"
                maxlength="50"
                pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,50}$"
                #razon_social="ngModel"
                name="RAZON_SOCIAL"
                requiered />
        </mat-form-field>

        <mat-form-field hideRequiredMarker class="w-full">
            <mat-label>Rut</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                [(ngModel)]="infoPagareFormulario24.RUT.VALOR_RECURSO"
                name="rut"
                placeholder="Ej. 12.345.678-9"
                maxlength="12"
                #rut="ngModel"
                appRutValidation
                name="RUT"
                required />
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Representante Legal</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Representante Legal"
                [(ngModel)]="infoPagareFormulario24.REPRESENTANTE_LEGAL.VALOR_RECURSO"
                maxlength="100"
                pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,100}$"
                #representante_legal="ngModel"
                name="REPRESENTANTE_LEGAL"
                requiered />
        </mat-form-field>

        <mat-form-field appearance="fill" hideRequiredMarker class="w-full">
            <mat-label>Fecha escritura pública</mat-label>
            <input
                matInput
                [matDatepicker]="datepicker"
                [formControl]="date"
                [(ngModel)]="infoPagareFormulario24.FECHA_ESCRITURA_PUBLICA.VALOR_RECURSO"
                class="py-[18px] title-9 font-semibold"
                required />
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancelar</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Aplicar</button>
                </mat-datepicker-actions>
            </mat-datepicker>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Fono cobranza</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Fono"
                [(ngModel)]="infoPagareFormulario24.FONO.VALOR_RECURSO"
                maxlength="12"
                mask="0*"
                #fono="ngModel"
                name="FONO" />
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Dirección</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Dirección"
                [(ngModel)]="infoPagareFormulario24.DIRECCION.VALOR_RECURSO"
                maxlength="100"
                pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,100}$"
                #direccion="ngModel"
                name="DIRECCION"
                requiered />
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Comuna</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Comuna"
                [(ngModel)]="infoPagareFormulario24.COMUNA.VALOR_RECURSO"
                maxlength="50"
                pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,50}$"
                #Comuna="ngModel"
                name="COMUNA"
                requiered />
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Ciudad</mat-label>
            <input
                matInput
                type="text"
                class="h-[26px]"
                placeholder="Ciudad"
                [(ngModel)]="infoPagareFormulario24.CIUDAD.VALOR_RECURSO"
                maxlength="50"
                pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,50}$"
                #Ciudad="ngModel"
                name="CIUDAD"
                requiered />
        </mat-form-field>

        <button
            [disabled]="guardandoCambiosPagare || !formPagare.valid"
            mat-flat-button
            color="primary"
            (click)="guardarCambioPagareFormulario24()"
            class="w-full my-5 text-lg md:w-48 title-9">
            <span *ngIf="!guardandoCambiosPagare"> Guardar</span>
            <mat-progress-spinner *ngIf="guardandoCambiosPagare" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
        </button>
    </form>
</main>
